// ****************************** Import Modals ******************************** //

//*** User Error Modal *** //
import '/src/popups/user-popup.js';
import '/src/popups/user-popup.css';

// ********************** User Popup Modal *********************** //

var userPopup = document.getElementById('user-popup');
var popupClose = document.getElementById('popup-close');

popupClose.onclick = function() {
  	userPopup.style.display = "none";
}

// ****************************** JS - Email Signup Form ******************************** //

const scriptURL = 'https://script.google.com/macros/s/AKfycbxue0ErvY_Q9uMjJ6yY8zH3WkTjddT3GxB5tlTtfU0sCRbRtBU-Lgc3CfqrBhYgxiEX/exec';
			
const submitButton = document.getElementById("submit-button");
			
const form = document.forms["submit-to-google-sheet"];
			
			
submitButton.addEventListener('click', e => {
				
	e.preventDefault()

	let firstName = document.forms["submit-to-google-sheet"]["firstName"].value.trim();
  	let lastName = document.forms["submit-to-google-sheet"]["lastName"].value.trim();
  	let email = document.forms["submit-to-google-sheet"]["email"].value.trim();
				
	// console.log(firstName);
	// console.log(lastName);
	// console.log(email);

	const formData = new FormData(form);

	if (firstName == "") {
      	$("#popup-title").html('Oops! Missing Info');
      	$("#popup-main-text").html('Please enter your first name.');
      	userPopup.style.display = "block";
    	return false;

    } else if (lastName == "") {
      	$("#popup-title").html('Oops! Missing Info');
      	$("#popup-main-text").html('Please enter your last name.');
      	userPopup.style.display = "block";
    	return false;
    
    } else if (email == "") {
      	$("#popup-title").html('Oops! Missing Info');
      	$("#popup-main-text").html('Please enter your email address.');
      	userPopup.style.display = "block";
    	return false;

    } else {
		submitEmailSignup(formData);  
	}
});


function submitEmailSignup(formData) {

	// console.log("About to submit");

	submitButton.disabled = true;
    submitButton.value = "Submitting...";

  	fetch(scriptURL, { method: "POST", body: formData })
  		
  		.then((response) => response.json())
  	
  			.then ((result) =>  { 

			    console.log('Submission Result:', result.result);

			    console.log('data:', result.data);

    			var errorMessage = "";

    if (result.result == 'success') {
    	
    	submitButton.disabled = false;
      	submitButton.value = "Thank you!";
	  
	  	$("#popup-title").html('Thank You!');
      	$("#popup-main-text").html("You've been added to our email list.");
      	userPopup.style.display = "block";
       
       	form.reset(); 

    	submitButton.value = "Submit";
    }

    if (result.result == 'error') {

    	// console.log('Submission Result:', result.result.e);

    	$("#popup-title").html('Oops!');
      	$("#popup-main-text").html('Something went wrong.');
      	$("#popup-sub-text").html('Please try again.');
      	userPopup.style.display = "block";

      	form.reset();
      	
      	submitButton.disabled = false;
      	submitButton.value = "Submit";
    }
  })
    .catch(error => { 

        $("#popup-title").html('Oops!');
      	$("#popup-main-text").html('Something went wrong.');
      	$("#popup-sub-text").html('Please try again.');
      	userPopup.style.display = "block";
            
    	form.reset(); 

    	submitButton.disabled = false;
      	submitButton.value = "Submit";
  });
}

